const initialized = new WeakSet();
function initializeReviews() {
  document.querySelectorAll('.elirena-reviews-block').forEach(root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const cards = [...root.querySelectorAll('[data-elirena-review]')];
    const button = root.querySelector('[data-elirena-load-more]');
    let shown = 3;
    let clicks = 0;
    const update = () => {
      cards.forEach((card, index) => { card.hidden = index >= shown; });
      if (button) button.parentElement.hidden = shown >= cards.length;
    };
    update();
    button?.addEventListener('click', () => {
      const firstNewCard = cards[shown];
      shown += clicks++ === 0 ? 3 : 6;
      update();
      if (firstNewCard) { firstNewCard.tabIndex = -1; firstNewCard.focus({ preventScroll: true }); }
    });
  });
}
function scrollToReviews() {
  const section = document.getElementById('customer-reviews');
  if (!section) return;
  const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')) || document.getElementById('header-group')?.getBoundingClientRect().height || 0;
  window.scrollTo({ top: window.scrollY + section.getBoundingClientRect().top - headerHeight - 14, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  section.focus({ preventScroll: true });
}
document.addEventListener('click', event => {
  const link = event.target.closest('a[href="#customer-reviews"]');
  if (!link || !document.getElementById('customer-reviews')) return;
  event.preventDefault();
  history.replaceState(null, '', '#customer-reviews');
  scrollToReviews();
  const settle = () => { scrollToReviews(); window.removeEventListener('scrollend', settle); };
  window.addEventListener('scrollend', settle, { once: true });
});
document.addEventListener('shopify:section:load', initializeReviews);
document.addEventListener('shopify:block:select', event => {
  const card = event.target.closest('[data-elirena-review]');
  if (card) card.hidden = false;
});
initializeReviews();
